/* WicoTreats 3.1: koopknoppen, koopblok op kaarten, private label studio */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));
  const B = window.BRUUN || {};
  const T = window.WICO_T || {};
  const reduceMotion = () => window.matchMedia('(prefers-reduced-motion: reduce)').matches || !document.body.classList.contains('motion-on');
  const debounce = (fn, wait = 150) => { let t; return (...a) => { clearTimeout(t); t = setTimeout(() => fn(...a), wait); }; };

  const ICON_BAG = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round"><path d="M5 8h14l-1.2 12H6.2L5 8Z"/><path d="M9 8V6.5a3 3 0 0 1 6 0V8"/></svg>';
  const ICON_OK = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" stroke-linejoin="round"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';

  /* ---------- Koopknop productpagina: icoon, vulanimatie en 'Toegevoegd' ---------- */
  function buildBuyButton(btn) {
    if ($('[data-btn-label]', btn)) return;
    const text = btn.textContent.trim();
    btn._building = true;
    btn.innerHTML = '';
    const icon = document.createElement('span');
    icon.className = 'btn__icon'; icon.setAttribute('aria-hidden', 'true'); icon.innerHTML = ICON_BAG;
    const label = document.createElement('span');
    label.setAttribute('data-btn-label', ''); label.textContent = text;
    const done = document.createElement('span');
    done.className = 'btn__done'; done.setAttribute('aria-hidden', 'true'); done.innerHTML = ICON_OK + (T.added || '');
    btn.append(icon, label, done);
    btn._building = false;
  }
  function initBuyButtons(root = document) {
    $$('[data-add-button]', root).forEach((btn) => {
      if (btn.dataset.wico4) return;
      btn.dataset.wico4 = '1';
      btn.classList.add('btn--buy');
      buildBuyButton(btn);
      // wico.js zet bij een andere maat de tekst opnieuw; dan bouwen we de knop weer op
      new MutationObserver(() => { if (!btn._building) buildBuyButton(btn); }).observe(btn, { childList: true });
    });
    $$('[data-sticky-add]', root).forEach((btn) => btn.classList.add('btn--buy'));
  }
  function patchCart() {
    const C = B.Cart;
    if (!C || C._wico4) return;
    C._wico4 = true;
    const orig = C.markNew.bind(C);
    C.markNew = (ids, button) => {
      orig(ids, button);
      if (button && button.classList.contains('btn--buy')) {
        button.classList.add('is-added');
        setTimeout(() => button.classList.remove('is-added'), 1800);
      }
    };
  }

  /* ---------- Koopblok op productkaarten: maat kiezen werkt de prijs bij ---------- */
  function syncCard(wrap) {
    const picked = $('input[type="radio"][name="id"]:checked', wrap);
    if (!picked || !picked.dataset.price) return;
    const card = wrap.closest('[data-card]');
    if (!card) return;
    const now = $('[data-card-price] .price__now', card);
    if (now) now.innerHTML = picked.dataset.price;
    const from = $('[data-card-price] .price__from', card);
    if (from) from.hidden = true;
    const size = $('[data-card-price] .pcard__size', card);
    if (size) size.hidden = true;
  }
  function initCardBuy(root = document) {
    $$('[data-cardbuy]', root).forEach((wrap) => { if ($('input[type="radio"]', wrap)) syncCard(wrap); });
  }
  document.addEventListener('change', (e) => {
    const wrap = e.target.closest && e.target.closest('[data-cardbuy]');
    if (wrap && e.target.matches('input[type="radio"][name="id"]')) syncCard(wrap);
  });

  /* ---------- Private label: zak met live merknaam, kleurwissel, stappenlijn ---------- */
  function initPlStudio(root = document) {
    $$('[data-pl-studio]', root).forEach((studio) => {
      if (studio.dataset.ready) return;
      studio.dataset.ready = '1';
      const pouch = $('[data-pl-pouch]', studio);
      const brand = $('[data-pl-brand]', studio);
      const kind = $('[data-pl-kind]', studio);
      const stamp = $('[data-pl-stamp]', studio);
      const input = $('[data-pl-input]', studio);
      const stage = $('[data-pl-stage]', studio);
      const dots = $$('[data-pl-dier]', studio);
      const fallback = brand ? brand.textContent : '';
      const still = reduceMotion();

      // Teksten op het etiket passend maken (lange merknamen en lange vertalingen)
      const fit = () => {
        $$('[data-pl-fit]', studio).forEach((el) => {
          el.style.fontSize = '';
          try {
            const max = Number(el.dataset.plFit) || 150;
            const w = el.getComputedTextLength();
            if (w > max) {
              const px = parseFloat(getComputedStyle(el).fontSize) || 16;
              el.style.fontSize = Math.max(8, Math.floor(px * max / w * 10) / 10) + 'px';
            }
          } catch (e) { /* nog niet zichtbaar */ }
        });
      };

      let idx = 0;
      let timer = null;
      const setDier = (i) => {
        if (!pouch || !dots.length) return;
        idx = (i + dots.length) % dots.length;
        const d = dots[idx];
        pouch.className = pouch.className.replace(/\bdier-[a-z]+\b/g, '').trim() + ' dier-' + d.dataset.plDier;
        if (kind) kind.textContent = (d.dataset.plName || '').toUpperCase();
        fit();
        dots.forEach((x, n) => x.classList.toggle('is-on', n === idx));
        pouch.classList.remove('is-swap'); void pouch.offsetWidth; pouch.classList.add('is-swap');
      };
      const play = () => { if (!still && !timer) timer = setInterval(() => setDier(idx + 1), 2600); };
      const stop = () => { clearInterval(timer); timer = null; };
      setDier(0);
      if ('IntersectionObserver' in window && stage) {
        new IntersectionObserver((en) => en.forEach((e) => (e.isIntersecting ? play() : stop()))).observe(stage);
      } else play();
      dots.forEach((d, n) => d.addEventListener('click', () => { stop(); setDier(n); play(); }));

      const field = $('[data-pl-brand-field]');
      if (input && brand) {
        input.addEventListener('input', () => {
          const v = input.value.trim().toUpperCase();
          brand.textContent = v || fallback;
          fit();
          if (field) field.value = input.value.trim();
          if (stamp) { stamp.classList.remove('is-on'); void stamp.offsetWidth; if (v) stamp.classList.add('is-on'); }
          if (pouch) { pouch.classList.remove('is-typed'); void pouch.offsetWidth; pouch.classList.add('is-typed'); }
        });
      }
      requestAnimationFrame(fit);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);

      if (stage && !still && window.matchMedia('(hover: hover)').matches) {
        stage.addEventListener('pointermove', (e) => {
          const r = stage.getBoundingClientRect();
          stage.style.setProperty('--mx', ((e.clientX - r.left) / r.width - 0.5).toFixed(3));
          stage.style.setProperty('--my', ((e.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
        stage.addEventListener('pointerleave', () => { stage.style.setProperty('--mx', 0); stage.style.setProperty('--my', 0); });
      }

      const track = $('[data-pl-steps]', studio);
      const bar = $('[data-pl-progress]', studio);
      const steps = $$('[data-pl-step]', studio);
      if (track && bar && steps.length) {
        const update = () => {
          const r = track.getBoundingClientRect();
          const vh = window.innerHeight;
          const p = Math.min(1, Math.max(0, (vh * 0.75 - r.top) / (r.height * 0.8)));
          bar.style.setProperty('--p', still ? 1 : p.toFixed(3));
          steps.forEach((st, n) => st.classList.toggle('is-on', still || p >= (n + 0.35) / steps.length));
        };
        update();
        window.addEventListener('scroll', update, { passive: true });
        window.addEventListener('resize', debounce(update));
      }
    });
  }

  /* ---------- Menu open? Dan krijgt de body een klasse (voor browsers zonder :has) ---------- */
  function watchMenu() {
    const menu = $('#MenuDrawer');
    if (!menu || menu._wico4) return;
    menu._wico4 = true;
    const sync = () => document.body.classList.toggle('menu-open', menu.classList.contains('is-open'));
    new MutationObserver(sync).observe(menu, { attributes: true, attributeFilter: ['class'] });
    sync();
  }

  function initAll(root = document) {
    watchMenu();
    initBuyButtons(root);
    initCardBuy(root);
    initPlStudio(root);
  }
  const start = () => {
    patchCart();
    initAll();
    // Aanbevelingen worden later geladen
    $$('[data-recommendations-list]').forEach((list) => new MutationObserver(() => initCardBuy(list)).observe(list, { childList: true }));
    document.addEventListener('shopify:section:load', (e) => initAll(e.target));
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
